import React from "react";
import { useGlobalContext } from "../context";

const SearchForm = () => {
  const { setSearchTerm } = useGlobalContext();
  const searchValue = React.useRef("");

  const handleSearch = (e) => {
    setSearchTerm(searchValue.current.value);
  };

  React.useEffect(() => {
    searchValue.current.focus();
  }, []);

  return (
    <section className="section search">
      <form className="search-form" onSubmit={(e) => e.preventDefault()}>
        <div className="form-control">
          <label htmlFor="name">Search your Favourite cocktail</label>
          <input
            type="text"
            id="name"
            ref={searchValue}
            onChange={handleSearch}
          />
        </div>
      </form>
    </section>
  );
};

export default SearchForm;
